import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";
import React, { useMemo } from "react";
import classNames from "classnames";
import { Icon, makeStyles, Typography, RaiseColors, IconConstants } from "componentLibrary";
import { Tooltip } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var ReactionButtonTypes = /*#__PURE__*/function (ReactionButtonTypes) {
  ReactionButtonTypes["LIKES"] = "likes";
  ReactionButtonTypes["DISLIKES"] = "dislikes";
  ReactionButtonTypes["COMMENTS"] = "comments";
  ReactionButtonTypes["TOUR_REQUESTS"] = "tourRequests";
  return ReactionButtonTypes;
}({});
var useStyles = makeStyles(function (theme) {
  return {
    button: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "24px",
      padding: "1px 10px",
      transition: "all 0.15s ease-in-out",
      backgroundColor: RaiseColors.white,
      borderColor: RaiseColors.grayscale200,
      "&:hover": {
        borderColor: RaiseColors.glacier400
      },
      "&:active": {
        borderColor: function borderColor(props) {
          return props.highlightColor;
        },
        boxShadow: function boxShadow(props) {
          return "0px 0px 0px 3px ".concat(props.highlightColor, "14 !important");
        }
      }
    },
    icon: {
      pointerEvents: "none",
      fontWeight: 500
    },
    count: {
      pointerEvents: "none"
    },
    activeState: {
      color: function color(props) {
        return props.highlightColor;
      },
      backgroundColor: function backgroundColor(props) {
        return props.highlightBgColor;
      },
      borderColor: function borderColor(props) {
        return props.highlightColor;
      },
      "&:hover": {
        borderColor: RaiseColors.glacier400
      }
    },
    customTooltip: {
      backgroundColor: RaiseColors.white,
      color: RaiseColors.black,
      borderRadius: "8px !important",
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15) !important",
      padding: "12px 12px 8px 12px",
      maxWidth: "200px !important",
      transform: "translateX(-2px) !important"
    },
    tooltipHeader: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
      marginBottom: "4px"
    },
    tooltipIcon: {
      display: "flex",
      borderRadius: "50%",
      alignItems: "center",
      justifyContent: "center",
      width: "22px !important",
      height: "22px !important",
      fontWeight: 500,
      backgroundColor: function backgroundColor(props) {
        return props.highlightBgColor;
      }
    },
    userList: {
      display: "flex",
      flexDirection: "column",
      gap: "4px"
    }
  };
});
var getReactionConfig = function getReactionConfig(reactionType, listing) {
  var _listing$likeCount, _context, _listing$likedBy, _listing$dislikeCount, _context2, _listing$dislikedBy;
  switch (reactionType) {
    case ReactionButtonTypes.LIKES:
      return {
        icon: IconConstants.THUMBS_UP,
        count: (_listing$likeCount = listing.likeCount) !== null && _listing$likeCount !== void 0 ? _listing$likeCount : 0,
        isActive: listing.currentUserLikeStatus === true,
        tooltipTitle: "Liked by",
        users: _filterInstanceProperty(_context = (_listing$likedBy = listing.likedBy) !== null && _listing$likedBy !== void 0 ? _listing$likedBy : []).call(_context, Boolean),
        highlightBgColor: RaiseColors.success100,
        highlightColor: RaiseColors.success500,
        iconColor: RaiseColors.success500
      };
    case ReactionButtonTypes.DISLIKES:
      return {
        icon: IconConstants.THUMBS_DOWN,
        count: (_listing$dislikeCount = listing.dislikeCount) !== null && _listing$dislikeCount !== void 0 ? _listing$dislikeCount : 0,
        isActive: listing.currentUserLikeStatus === false,
        tooltipTitle: "Disliked by",
        users: _filterInstanceProperty(_context2 = (_listing$dislikedBy = listing.dislikedBy) !== null && _listing$dislikedBy !== void 0 ? _listing$dislikedBy : []).call(_context2, Boolean),
        highlightBgColor: RaiseColors.warning100,
        highlightColor: RaiseColors.warning500,
        iconColor: RaiseColors.warning500
      };
    case ReactionButtonTypes.COMMENTS:
      {
        var _context3, _context4, _listing$conversation, _listing$conversation2, _listing$conversation3, _listing$conversation4;
        var commentedBy = _filterInstanceProperty(_context3 = _mapInstanceProperty(_context4 = (_listing$conversation = (_listing$conversation2 = listing.conversation) === null || _listing$conversation2 === void 0 ? void 0 : _listing$conversation2.comments) !== null && _listing$conversation !== void 0 ? _listing$conversation : []).call(_context4, function (comment) {
          return comment === null || comment === void 0 ? void 0 : comment.sender;
        })).call(_context3, Boolean);
        var uniqueCommenters = _filterInstanceProperty(commentedBy).call(commentedBy, function (user, index, self) {
          return index === _findIndexInstanceProperty(self).call(self, function (u) {
            return u.fullName === user.fullName;
          });
        });
        return {
          icon: IconConstants.CHAT_CIRCLE,
          count: (_listing$conversation3 = (_listing$conversation4 = listing.conversation) === null || _listing$conversation4 === void 0 ? void 0 : _listing$conversation4.commentCount) !== null && _listing$conversation3 !== void 0 ? _listing$conversation3 : 0,
          isActive: false,
          tooltipTitle: "Comments by",
          users: uniqueCommenters,
          highlightBgColor: RaiseColors.white,
          highlightColor: RaiseColors.glacier400,
          iconColor: RaiseColors.glacier2400
        };
      }
    case ReactionButtonTypes.TOUR_REQUESTS:
      {
        var _context5, _context6, _listing$tourRequests;
        var tourRequestBy = _filterInstanceProperty(_context5 = _mapInstanceProperty(_context6 = (_listing$tourRequests = listing.tourRequests) !== null && _listing$tourRequests !== void 0 ? _listing$tourRequests : []).call(_context6, function (e) {
          return e === null || e === void 0 ? void 0 : e.user;
        })).call(_context5, Boolean);
        return {
          icon: IconConstants.MAP_PIN,
          count: tourRequestBy.length,
          isActive: listing.currentUserTourRequest === true,
          tooltipTitle: "Tour requested by",
          users: tourRequestBy,
          highlightBgColor: RaiseColors.science200,
          highlightColor: RaiseColors.science1500,
          iconColor: RaiseColors.science1500
        };
      }
    default:
      return {
        icon: "",
        count: 0,
        tooltipTitle: undefined,
        users: [],
        highlightBgColor: RaiseColors.gray400,
        highlightColor: RaiseColors.gray400
      };
  }
};
var ReactionButton = function ReactionButton(_ref) {
  var reactionType = _ref.reactionType,
    listing = _ref.listing,
    onClick = _ref.onClick;
  var reactionConfig = useMemo(function () {
    return getReactionConfig(reactionType, listing);
  }, [reactionType, listing]);
  var icon = reactionConfig.icon,
    count = reactionConfig.count,
    isActive = reactionConfig.isActive,
    tooltipTitle = reactionConfig.tooltipTitle,
    users = reactionConfig.users,
    highlightBgColor = reactionConfig.highlightBgColor,
    highlightColor = reactionConfig.highlightColor,
    iconColor = reactionConfig.iconColor;
  var classes = useStyles({
    highlightColor: highlightColor,
    highlightBgColor: highlightBgColor
  });
  var tooltipContent = useMemo(function () {
    return users.length > 0 && tooltipTitle ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: classes.tooltipHeader,
        children: [/*#__PURE__*/_jsx(Icon, {
          className: classNames(icon, classes.tooltipIcon),
          fontSize: "small",
          color: iconColor
        }), /*#__PURE__*/_jsxs(Typography, {
          variant: "paragraph_xsmall",
          weight: "semibold",
          children: [tooltipTitle, ":"]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: classes.userList,
        children: _mapInstanceProperty(users).call(users, function (user, index) {
          return /*#__PURE__*/_jsx(Typography, {
            variant: "paragraph_xsmall",
            weight: "medium",
            children: user.fullName
          }, index);
        })
      })]
    }) : null;
  }, [users, tooltipTitle, classes, icon, iconColor]);
  return /*#__PURE__*/_jsx(Tooltip, {
    disableHoverListener: users.length === 0,
    title: tooltipContent,
    placement: "bottom-start",
    componentsProps: {
      tooltip: {
        className: classes.customTooltip
      }
    },
    children: /*#__PURE__*/_jsxs("div", {
      className: classNames(classes.button, _defineProperty({}, classes.activeState, isActive && reactionType !== ReactionButtonTypes.COMMENTS)),
      onClick: onClick,
      style: {
        cursor: onClick ? "pointer" : "default"
      },
      children: [/*#__PURE__*/_jsx(Icon, {
        className: classNames(icon, classes.icon),
        color: isActive ? iconColor : RaiseColors.glacier2400,
        fontSize: "small"
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph_xsmall",
        weight: "medium",
        className: classes.count,
        color: isActive ? iconColor : RaiseColors.glacier2400,
        children: count
      })]
    })
  });
};
export default /*#__PURE__*/React.memo(ReactionButton);